import './public-path';
import './css/site.scss';
// TODO: How to enumerate this?
import './SignIn/css/styles.css';
import 'core-js/es/array';
import 'core-js/es/promise';
import { app } from './app';

// Disable Vue Devtools globally during investigation
if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
  try { window.__VUE_DEVTOOLS_GLOBAL_HOOK__.enabled = false; } catch { }
}

app.mount('#app');

export default app;
